import axios from "axios";
import { getHostName } from "api-helpers/getHostName.ts";

export default function () {
  return axios
    .get(`${getHostName()}/auth0/settings/`)
    .then((response) => response.data)
    .catch((error) => {
      console.error("There was an error fetching Auth0 details", error);
    });
}
